const plans = [
  { text: 'Basic', value: 'basic', translations: 5000, users: 3 },
  { text: 'Pro', value: 'pro', translations: 50000, users: 10 },
  { text: 'Premium', value: 'premium', translations: 100000, users: 20 },
];

const valueToObj = {};
plans.forEach(plan => { valueToObj[plan.value] = plan });

export const getPlanObj = (value: string) => valueToObj[value] || {};
export const getPricingText = (value: string) => getPlanObj(value).text || '';
export const defaultPlan = plans[0].value;
export default plans;
